// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-scroll {
    overflow: hidden !important;
    position: fixed;
    height: 100%;
    width: 100%;
}

.rk-modal {
    width: 100%;
    height: auto;
    min-height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed !important;
    overflow-y: auto;
    z-index: 5001;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.rk-modal .overlay {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    background: #000;
    opacity: .7;
    z-index: 1;
}

.rk-modal .modal-control-bar {
    position: relative;
    height: auto;
    text-align: left;
    padding: var(--sm_padding) var(--md_padding);
    min-height: 50px;
    align-items:center;
    display:flex;
    border-bottom: solid 1px #d9d9d9;
    background: var(--background-headers);
    line-height: 1.5;
    font-size: 14px;
    font-weight: bold;
    box-sizing: border-box;
}
.rk-modal .modal-control-bar .control-buttons {
    position: absolute;
    right: 10px;
    top: 10px;
}

.rk-modal .modal-control-bar.modal-bottom-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-bottom: none;
    border-top: solid 1px #d9d9d9;
    height: auto;
    justify-content: flex-end;
}

.modal-control-bar.modal-bottom-bar .control-buttons {
    position: initial;
    text-align: right;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.modal-control-bar.modal-bottom-bar .control-buttons > span {
    margin-right: var(--target_spacing);
}

.rk-modal .control-bar-error-message {
    color: red;
    font-weight: normal;
    margin-right: 20px;
}

.branching-logic-editor-wrapper {
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
}

.branching-logic-editor-wrapper .branching-logic-editor {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
    z-index: 5001;
    position: relative;
    background: #FFF;
    border-radius: 4px;
    overflow: hidden;
    padding-bottom: 49px;
}

.branching-logic-editor-wrapper .branching-logic-editor .then-editor {
    padding: 10px;
}

.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper {
    position: relative;
    padding-left: 51px;
    border-top: solid 1px #ddd;
}

.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper:first-child {
    border-top: none;
}

.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper .editor-left-label {
    line-height: 100%;
    height: 100%;
    background: #eee;
    text-align: left;
    width: 50px;
    position: absolute;
    left: 0;
    top: 0;
    border-right: solid 1px #ddd;
    border-bottom: solid 1px #ddd;
}

.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper .editor-left-label label {
    font-size: 16px;
    color: #666;
    position: absolute;
    top: 50%;
    text-align: center;
    left: 0;
    width: 100%;
    display: block;
    margin-top: -6px;
    font-weight: bold;
}
.rk-admin .editor-controls-button.modal-close {
    margin-right: 0;
}

@media screen and (max-width: 768px) {
    .rk-modal .modal-content { 
        min-height: 100%; 
        height: 100%;
        padding-bottom: 50px;
    }
    .rk-modal .modal-control-bar {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .rk-modal .modal-control-bar .control-buttons {
        top: 0;
        right: 0;
    }
    .rk-admin .editor-controls-button.modal-close {
        position: absolute;
        top: 0;
        right: 0;
        background:none;
        border:transparent;
        height: var(--min_touch_target);
        width: var(--min_touch_target);
    }
}`, "",{"version":3,"sources":["webpack://./src/modal.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,4CAA4C;IAC5C,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;IACnB;IACA;QACI,MAAM;QACN,QAAQ;IACZ;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,eAAe;QACf,kBAAkB;QAClB,+BAA+B;QAC/B,8BAA8B;IAClC;AACJ","sourcesContent":[".no-scroll {\n    overflow: hidden !important;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n}\n\n.rk-modal {\n    width: 100%;\n    height: auto;\n    min-height: 100%;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    position: fixed !important;\n    overflow-y: auto;\n    z-index: 5001;\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box;\n}\n\n.rk-modal .overlay {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    background: #000;\n    opacity: .7;\n    z-index: 1;\n}\n\n.rk-modal .modal-control-bar {\n    position: relative;\n    height: auto;\n    text-align: left;\n    padding: var(--sm_padding) var(--md_padding);\n    min-height: 50px;\n    align-items:center;\n    display:flex;\n    border-bottom: solid 1px #d9d9d9;\n    background: var(--background-headers);\n    line-height: 1.5;\n    font-size: 14px;\n    font-weight: bold;\n    box-sizing: border-box;\n}\n.rk-modal .modal-control-bar .control-buttons {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n\n.rk-modal .modal-control-bar.modal-bottom-bar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    border-bottom: none;\n    border-top: solid 1px #d9d9d9;\n    height: auto;\n    justify-content: flex-end;\n}\n\n.modal-control-bar.modal-bottom-bar .control-buttons {\n    position: initial;\n    text-align: right;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.modal-control-bar.modal-bottom-bar .control-buttons > span {\n    margin-right: var(--target_spacing);\n}\n\n.rk-modal .control-bar-error-message {\n    color: red;\n    font-weight: normal;\n    margin-right: 20px;\n}\n\n.branching-logic-editor-wrapper {\n    width: 100%;\n    padding-left: 40px;\n    padding-right: 40px;\n    box-sizing: border-box;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor {\n    width: 100%;\n    margin-top: 40px;\n    margin-bottom: 40px;\n    z-index: 5001;\n    position: relative;\n    background: #FFF;\n    border-radius: 4px;\n    overflow: hidden;\n    padding-bottom: 49px;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor .then-editor {\n    padding: 10px;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper {\n    position: relative;\n    padding-left: 51px;\n    border-top: solid 1px #ddd;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper:first-child {\n    border-top: none;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper .editor-left-label {\n    line-height: 100%;\n    height: 100%;\n    background: #eee;\n    text-align: left;\n    width: 50px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    border-right: solid 1px #ddd;\n    border-bottom: solid 1px #ddd;\n}\n\n.branching-logic-editor-wrapper .branching-logic-editor .editor-wrapper .editor-left-label label {\n    font-size: 16px;\n    color: #666;\n    position: absolute;\n    top: 50%;\n    text-align: center;\n    left: 0;\n    width: 100%;\n    display: block;\n    margin-top: -6px;\n    font-weight: bold;\n}\n.rk-admin .editor-controls-button.modal-close {\n    margin-right: 0;\n}\n\n@media screen and (max-width: 768px) {\n    .rk-modal .modal-content { \n        min-height: 100%; \n        height: 100%;\n        padding-bottom: 50px;\n    }\n    .rk-modal .modal-control-bar {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n    }\n    .rk-modal .modal-control-bar .control-buttons {\n        top: 0;\n        right: 0;\n    }\n    .rk-admin .editor-controls-button.modal-close {\n        position: absolute;\n        top: 0;\n        right: 0;\n        background:none;\n        border:transparent;\n        height: var(--min_touch_target);\n        width: var(--min_touch_target);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
